export interface NewUser {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export const getEmptyNewUser = (): NewUser => ({
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
});

export const newUserToInsertRequest = (newUser: NewUser) => ({
  first_name: newUser.firstName,
  last_name: newUser.lastName,
  email: newUser.email,
  phone: newUser.phone,
});
